import React from 'react';
import { FiX } from 'react-icons/fi';

/**
 * Shared with the /wishlist page and the Cart page's WishlistSlider — asks
 * which size to add when a wishlisted product has more than one available.
 */
const SizeSelectionPopup = ({
  open,
  sizeOptions,
  selectedVariation,
  onSelect,
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 px-4">
      <div className="bg-white p-6 rounded-2xl shadow-xl w-full max-w-sm">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-bold text-gray-900">Select Size</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100"
          >
            <FiX size={16} />
          </button>
        </div>

        <div className="flex flex-wrap gap-2 mb-5">
          {sizeOptions.map((v) => (
            <button
              type="button"
              key={v.id}
              onClick={() => onSelect(v)}
              className={`px-4 h-10 flex items-center justify-center rounded-xl text-sm font-semibold border transition-colors
                            ${selectedVariation?.id === v.id
                  ? 'bg-brand-600 text-white border-brand-600'
                  : 'bg-gray-50 text-gray-700 border-gray-200 hover:border-gray-300'}`}
            >
              {v.size}
            </button>
          ))}
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl bg-gray-100 text-gray-700 text-sm font-semibold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!selectedVariation}
            className="px-4 py-2 rounded-xl text-sm font-semibold text-white bg-brand-600 hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default SizeSelectionPopup;
